document.addEventListener('DOMContentLoaded', function () {
  var menu = document.querySelector('.nye-mobile-menu');
  if (!menu) return;
  menu.addEventListener('click', function (event) {
    if (event.target.closest('a')) menu.open = false;
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && menu.open) {
      menu.open = false;
      menu.querySelector('summary').focus();
    }
  });
  document.addEventListener('click', function (event) {
    if (!menu.contains(event.target)) menu.open = false;
  });
});

(function () {
  'use strict';
  if (window.__nyeGrowthTracking) return;
  window.__nyeGrowthTracking = true;
  var version = '2026-09-30.2';
  var views = ['nye64', 'nyeplay', 'nyecade', 'nyecity', 'nyemuseum', 'nyeconomy'];
  var booted = false;
  var lastControl = '';
  var lastControlAt = 0;
  var observed = {};
  function safe(value) {
    value = String(value || '').trim();
    if (/@|%40|[0-9]{9,}/i.test(value)) return '';
    return value.replace(/[^a-zA-Z0-9 _.:/\-]/g, '').slice(0, 100);
  }
  function route(raw) {
    try {
      var u = new URL(raw, window.location.href);
      if (!/^https?:$/.test(u.protocol)) return null;
      var path = u.pathname;
      if (/^\/(?:account|checkouts?|orders|authentication|challenge)(?:\/|$)/.test(path)) path = '/private';
      var view = u.searchParams.get('view');
      return { host: u.hostname, path: safe(path), view: views.indexOf(view) >= 0 ? view : '',
        anchor: safe(u.hash.slice(1)), video: /^(?:www\.)?youtube\.com$/.test(u.hostname) ? safe(u.searchParams.get('v')) : '' };
    } catch (_) { return null; }
  }
  function allowed() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      return !!(p && p.analyticsProcessingAllowed && p.analyticsProcessingAllowed());
    } catch (_) { return false; }
  }
  function emit(name, fields) {
    if (!allowed()) return false;
    var shopify = window.Shopify;
    if (!shopify.analytics || typeof shopify.analytics.publish !== 'function') return false;
    var here = route(window.location.href);
    if (!here || here.path === '/private') return false;
    var data = { schema_version: version, page_path: here.path, page_view: here.view || 'default' };
    Object.keys(fields || {}).forEach(function (key) {
      var value = fields[key];
      if (typeof value === 'number' && isFinite(value)) data[key] = value;
      else if (typeof value === 'string') data[key] = safe(value);
    });
    try {
      var result = shopify.analytics.publish('nye:' + name, data);
      if (result && result.catch) result.catch(function () {});
      return true;
    } catch (_) { return false; }
  }
  function placement(el) {
    var owner = el.closest('section[id], footer, header, nav, [data-nye-tv], [data-nye64]');
    if (!owner) return 'site';
    return safe(owner.id || owner.tagName.toLowerCase());
  }
  function game() {
    var selected = document.querySelector('[data-cart][aria-pressed="true"]');
    return selected ? safe(selected.getAttribute('data-cart')) : '';
  }
  function control(el) {
    var attrs = ['data-paint-action','data-passport-open','data-passport-start','data-passport-close',
      'data-passport-reset','data-passport-erase','data-passport-cancel','data-tv-power',
      'data-start','data-screen-start','data-pause','data-eject','data-sound','data-expand',
      'data-library','data-gallery-visit','data-stack-pause','data-stack-retry','data-stack-undo',
      'data-jam-undo','data-jam-retry','data-room-paint-toggle','data-weather',
      'data-district','data-actor','data-travel','data-walk','data-city-drain',
      'data-auto','data-sky','data-stories','data-view','data-room','data-room-index'];
    for (var i = 0; i < attrs.length; i++) {
      if (el.hasAttribute(attrs[i])) return safe(attrs[i].slice(5) + (el.getAttribute(attrs[i]) ? ':' + el.getAttribute(attrs[i]) : ''));
    }
    return safe(el.id || (el.getAttribute('aria-controls') ? 'toggle:' + el.getAttribute('aria-controls') :
      el.tagName.toLowerCase() + ':' + Array.from(el.classList).slice(0, 2).join('.')));
  }
  function click(event) {
    if (event.type === 'auxclick' ? event.button !== 1 : event.button > 0) return;
    var target = event.target && (event.target.nodeType === 1 ? event.target : event.target.parentElement);
    var el = target && target.closest('a[href],button,summary,[role="button"]');
    if (!el || el.disabled || el.closest('[data-nye-no-track],input,textarea,[contenteditable="true"]')) return;
    var fields = { placement: placement(el), control_id: control(el) };
    if (el.matches('a[href]')) {
      var dest = route(el.href);
      if (!dest) return;
      fields.destination_host = dest.host;
      fields.destination_path = dest.path;
      fields.destination_view = dest.view;
      fields.destination_anchor = dest.anchor;
      if (dest.video) fields.content_id = dest.video;
      var record = el.closest('[id^="record-"]');
      if (record) fields.content_id = record.id.replace(/^record-/, '');
      if (el.hasAttribute('data-nye-social')) {
        fields.platform = safe(el.getAttribute('data-nye-social'));
        emit('social_click', fields);
      } else if (['open.spotify.com','music.apple.com','www.youtube.com','youtube.com','youtu.be'].indexOf(dest.host) !== -1) {
        fields.platform = dest.host.indexOf('spotify') !== -1 ? 'spotify' :
          dest.host.indexOf('apple') !== -1 ? 'apple_music' : 'youtube';
        emit('listen_click', fields);
      } else if (dest.host === window.location.hostname && ['nye-backstage','nye-family'].indexOf(dest.anchor) !== -1) {
        fields.destination = dest.anchor === 'nye-family' ? 'free_email' : 'backstage';
        emit('join_interest', fields);
      } else if (dest.view || el.hasAttribute('data-arcade-launch')) {
        fields.game_id = safe(el.getAttribute('data-arcade-launch'));
        emit('experience_open', fields);
      } else emit('site_click', fields);
      return;
    }
    if (el.closest('form') || el.hasAttribute('data-key') || el.closest('[data-nye-game-controls]')) return;
    if (el.hasAttribute('data-game')) {
      fields.game_id = safe(el.getAttribute('data-game'));
      emit('game_launch_intent', fields);
    } else if (el.hasAttribute('data-cart')) {
      fields.game_id = safe(el.getAttribute('data-cart'));
      emit('game_select', fields);
    } else if (el.hasAttribute('data-tv-channel')) {
      fields.content_id = safe(el.getAttribute('data-tv-channel'));
      fields.content_title = safe(el.getAttribute('data-tv-title'));
      emit('video_select', fields);
    } else {
      var id = fields.control_id;
      if (id === lastControl && Date.now() - lastControlAt < 500) return;
      lastControl = id; lastControlAt = Date.now();
      fields.game_id = game();
      if (/^(start|screen-start)$/.test(id)) emit('game_start_intent', fields);
      else if (/^tv-power/.test(id)) emit('video_power', fields);
      else emit('site_interaction', fields);
    }
  }
  document.addEventListener('click', click, true);
  document.addEventListener('auxclick', click, true);
  document.addEventListener('submit', function (event) {
    if (event.target.id === 'NyeNewsletter') emit('newsletter_submit', { placement: 'footer' });
  }, true);
  function ready() {
    if (!allowed()) return;
    if (!booted) {
      booted = emit('page_context', {});
      var success = document.querySelector('[data-nye-newsletter-success]');
      if (success) emit('newsletter_confirmed', { placement: 'footer' });
    }
    if (!window.IntersectionObserver) return;
    if (window.__nyeSectionObserver) return;
    window.__nyeSectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !observed[entry.target.id] && emit('section_view', { section_id: entry.target.id })) {
          observed[entry.target.id] = true;
        }
      });
    }, { threshold: 0.15 });
    ['music','watch','artist','nye-backstage','nye-family'].forEach(function (id) {
      var el = document.getElementById(id); if (el) window.__nyeSectionObserver.observe(el);
    });
  }
  var privacyRetries = 0;
  function privacyReady() {
    if (window.Shopify && window.Shopify.customerPrivacy) { ready(); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) ready();
      });
    } else if (++privacyRetries <= 10) {
      window.setTimeout(privacyReady, 500);
    }
  }
  document.addEventListener('visitorConsentCollected', function () {
    if (!allowed() && window.__nyeSectionObserver) {
      window.__nyeSectionObserver.disconnect(); window.__nyeSectionObserver = null;
    }
    ready();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', privacyReady);
  else privacyReady();
})();

(function(w,d){
  'use strict';
  if(w.NyeTracking)return;
  const version='2026-10-05.1';
  let visibleAt=performance.now(),visibleSeconds=0,clicks=0,listens=0,plays=0,shopping=0,flushed=false;
  const clean=v=>{v=String(v||'').trim();return /@|%40|\b\d{9,}\b/i.test(v)?'':v.replace(/[^a-zA-Z0-9 _.:/\-]/g,'').slice(0,100)};
  const allowed=()=>{try{return w.Shopify?.customerPrivacy?.analyticsProcessingAllowed()===true&&!/^\/(account|orders?|checkouts?|authentication|challenge)(\/|$)/.test(location.pathname)}catch{return false}};
  function route(raw){try{const u=new URL(raw,location.href);if(!/^https?:$/.test(u.protocol))return{};return{destination_host:u.hostname,destination_path:/^\/(account|orders?|checkouts?|authentication|challenge)(\/|$)/.test(u.pathname)?'/private':clean(u.pathname)}}catch{return{}}}
  function emit(name,data={}){
    if(!allowed()||!w.Shopify?.analytics?.publish)return false;
    const fields={schema_version:version,page_path:clean(location.pathname),page_view:clean(new URLSearchParams(location.search).get('view')||'default')};
    for(const [key,value] of Object.entries(data))if(typeof value==='number'&&Number.isFinite(value))fields[key]=value;else if(typeof value==='string')fields[key]=clean(value);
    try{Promise.resolve(w.Shopify.analytics.publish('nye:'+name,fields)).catch(()=>{});return true}catch{return false}
  }
  function note(name){if(!allowed())return;if(name==='game_start')plays++;if(name==='shopping_action')shopping++}
  function selectedGame(){const root=d.querySelector('[data-nye64]');return clean(root?.querySelector('[data-cart][aria-pressed="true"]')?.getAttribute('data-cart')||'')}
  function describe(el){
    const insideForm=!!el.closest('form'),tag=el.tagName.toLowerCase();
    const interactive=el.matches('a[href],button,summary,input,select,canvas,[role="button"],[role="tab"],[role="checkbox"],[data-key],[data-action],[data-nye-track]');
    const kind=interactive?(el.getAttribute('type')||el.getAttribute('role')||tag):'surface';
    let label='';
    if(interactive&&(!insideForm||tag==='button'||['submit','button','reset'].includes(kind)))label=clean(el.getAttribute('aria-label')||el.getAttribute('title')||el.textContent?.trim().replace(/\s+/g,' '));
    const keys=['data-nye-track','data-action','data-command','data-key','data-cart','data-game','data-shot','data-paint-action','data-tv-channel','data-weather','data-district','data-room','data-room-index','data-start','data-pause','data-eject'];
    let id='';for(const key of keys)if(el.hasAttribute(key)){id=key.slice(5)+':'+clean(el.getAttribute(key));break;}
    const owner=el.closest('section[id],header,footer,nav,[data-nye64],[data-nye-city]');
    const placement=clean(owner?.id||owner?.tagName.toLowerCase()||'site');
    if(!interactive)label='Background: '+placement;
    id=clean(id||el.id)||clean([placement,tag,label||Array.from(el.classList).slice(0,2).join('.')].join(':'));
    return{control_id:id||tag,control_label:label||id||tag,control_type:clean(kind),placement,game_id:selectedGame(),disabled:el.disabled||el.getAttribute('aria-disabled')==='true'?1:0};
  }
  function capture(event){
    if(!allowed()||(event.type==='pointerdown'&&event.button>1))return;
    // Pointer presses count once; click is retained only for keyboard/assistive activation.
    if(event.type==='click'&&event.detail!==0)return;
    const target=event.target?.nodeType===1?event.target:event.target?.parentElement;
    if(!target)return;
    const el=target.closest('a[href],button,summary,[role="button"],[role="tab"],[role="checkbox"],input,select,canvas,[data-key],[data-action],[data-nye-track]')||target;
    if(!el||el.closest('[data-nye-no-track],[contenteditable="true"]'))return;
    const fields=describe(el);fields.input_method=clean(event.pointerType||(event.type==='click'?'keyboard':'pointer'));
    if(el.matches('a[href]'))Object.assign(fields,route(el.href));
    if(el.tagName==='CANVAS'||fields.control_type==='surface'){
      const r=el.getBoundingClientRect();if(r.width&&r.height&&Number.isFinite(event.clientX)){fields.position_x=Math.round(100*(event.clientX-r.left)/r.width);fields.position_y=Math.round(100*(event.clientY-r.top)/r.height)}
    }
    if(emit('ui_click',fields))clicks++;
    const host=fields.destination_host||'';
    if(['open.spotify.com','music.apple.com','youtube.com','www.youtube.com','youtu.be'].includes(host))listens++;
    if(el.closest('form[action*="/cart/add"]')&&['submit','button'].includes(fields.control_type))shopping++;
  }
  d.addEventListener('pointerdown',capture,{capture:true,passive:true});
  d.addEventListener('click',capture,{capture:true,passive:true});
  d.addEventListener('change',event=>{
    const el=event.target;if(!el?.matches?.('select,input[type="checkbox"],input[type="radio"],input[type="range"]'))return;
    // Do not record choices from personal-information forms. Controls themselves remain counted.
    if(el.closest('form')&&!el.closest('form[action*="/cart/add"]'))return;
    const fields=describe(el);
    if(el.tagName==='SELECT')fields.choice=clean(el.selectedOptions?.[0]?.textContent);
    else if(el.type==='checkbox'||el.type==='radio')fields.checked=el.checked?1:0;
    emit('control_change',fields);
  },true);
  d.addEventListener('submit',event=>{const form=event.target;emit('form_submit',{control_id:clean(form.id)||'form',placement:clean(form.closest('section[id]')?.id)||'site'});},true);
  function accrue(){const now=performance.now();if(!d.hidden&&allowed())visibleSeconds+=Math.max(0,(now-visibleAt)/1000);visibleAt=now;}
  let timer=setInterval(accrue,1000);
  function outcome(reason){if(flushed)return;accrue();if(emit('visit_exit',{reason,outcome:listens?'listening_handoff':plays?'game_played':shopping?'shopping_action':clicks?'interaction':'no_recorded_action',visible_seconds:Math.round(visibleSeconds),click_count:clicks,listen_count:listens,game_count:plays})){flushed=true}}
  d.addEventListener('visibilitychange',()=>{accrue();if(d.hidden)outcome('page_hidden');else{flushed=false;visibleAt=performance.now()}});
  w.addEventListener('pagehide',()=>{outcome('page_exit');clearInterval(timer)});
  w.addEventListener('pageshow',e=>{if(e.persisted){flushed=false;visibleAt=performance.now();clearInterval(timer);timer=setInterval(accrue,1000)}});
  d.addEventListener('visitorConsentCollected',()=>{visibleAt=performance.now();if(!allowed()){visibleSeconds=clicks=listens=plays=shopping=0;flushed=false}});
  function arcadeUrl(raw) {
    let url;try{url=new URL(raw,location.href)}catch{return raw}
    if(url.origin!=='https://nye-arcade.2fj6f4dsth.workers.dev')return raw;
    const params=new URLSearchParams({nye_a:allowed()?'1':'0',nye_t:String(Date.now())});
    if(allowed())try{const value=d.cookie.split('; ').find(x=>x.startsWith('_nye_arcade_ga='));const data=JSON.parse(decodeURIComponent(value?.slice(15)||''));
      if(Date.now()-data.at>=0&&Date.now()-data.at<1800000&&/^[A-Za-z0-9.\-]{8,100}$/.test(data.cid)&&/^[0-9]{1,20}$/.test(data.sid)){params.set('nye_cid',data.cid);params.set('nye_sid',data.sid)}
    }catch{}
    url.hash=params.toString();return url.href;
  }
  w.NyeTracking=Object.freeze({version,emit,note,describe,allowed,arcadeUrl});
})(window,document);

/* Consented fan activity. No cookies, identity fields, or network destination here. */
(function (global) {
  'use strict';
  if (global.NyeEngagement) return;
  const fields = new Set(['game_id', 'surface', 'platform', 'placement', 'destination', 'level', 'score', 'outcome', 'reason', 'active_seconds', 'room_id']);
  const events = new Set(['game_download_start', 'game_load_error', 'game_launch', 'game_ready', 'game_start', 'game_resume', 'game_pause', 'game_end', 'game_engagement', 'level_start', 'level_end', 'arcade_room_view']);
  const trackers = new Set();
  let lastInput = performance.now();
  function allowed() {
    try { return global.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function publish(name, values) {
    if (!allowed() || !events.has(name) || !global.Shopify?.analytics?.publish) return false;
    const data = {};
    for (const [key, value] of Object.entries(values || {})) {
      if (!fields.has(key)) continue;
      if (typeof value === 'number' && Number.isFinite(value)) data[key] = Math.max(0, Math.min(value, 1e9));
      else if (typeof value === 'string' && /^[a-zA-Z0-9_.:/ -]{1,80}$/.test(value)) data[key] = value;
    }
    try { global.NyeTracking?.note(name); Promise.resolve(global.Shopify.analytics.publish('nye:' + name, data)).catch(() => {}); return true; }
    catch (_) { return false; }
  }
  for (const type of ['pointerdown', 'pointermove', 'keydown', 'touchstart']) {
    document.addEventListener(type, () => { lastInput = performance.now(); }, { passive: true });
  }
  function createGame(gameId, surface) {
    const base = { game_id: gameId, surface };
    let state = 'empty', level = '', score, seconds = 0, started = false, consentStart = false, closed = false;
    function flush(reason) {
      if (seconds >= 0.1) publish('game_engagement', { ...base, level, active_seconds: Math.round(seconds * 1000) / 1000, reason });
      seconds = 0;
    }
    function announce() {
      if (!consentStart && started && allowed()) consentStart = publish('game_start', { ...base, level });
    }
    const tracker = {
      activity() { lastInput = performance.now(); },
      update(next, nextLevel, nextScore) {
        if (closed) return;
        if (nextScore !== undefined && Number.isFinite(nextScore)) score = nextScore;
        const newLevel = nextLevel === undefined || nextLevel === null ? '' : String(nextLevel);
        if (state === 'playing' && next !== 'playing') flush(next);
        const previous = state;
        const changedLevel = newLevel !== level;
        level = newLevel;
        state = next;
        if (next === 'playing') {
          if (!started) { started = true; consentStart = false; announce(); }
          else if (previous === 'paused') publish('game_resume', { ...base, level });
          else if ((changedLevel || previous === 'cleared' || previous === 'ready') && previous !== 'playing') publish('level_start', { ...base, level });
        } else if (next === 'paused' && previous === 'playing') publish('game_pause', { ...base, level });
        else if (next === 'cleared' && previous !== 'cleared') publish('level_end', { ...base, level, score, outcome: 'cleared' });
        else if (['won', 'lost'].includes(next) && next !== previous && started) {
          publish('game_end', { ...base, level, score, outcome: next });
          started = false; consentStart = false;
        }
      },
      tick(dt, visible = true) {
        if (closed || !allowed()) { seconds = 0; consentStart = false; return; }
        if (state !== 'playing' || document.hidden || !visible || performance.now() - lastInput > 120000) return;
        announce();
        if (!Number.isFinite(dt) || dt <= 0) return;
        seconds += Math.min(dt, 1);
        if (seconds >= 15) flush('heartbeat');
      },
      flush,
      close(reason = 'closed') {
        if (closed) return;
        flush(reason);
        if (started) publish('game_end', { ...base, level, score, outcome: 'abandoned', reason });
        closed = true; trackers.delete(tracker);
      },
      revoke() { seconds = 0; consentStart = false; },
    };
    trackers.add(tracker);
    return tracker;
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) trackers.forEach(t => t.flush('hidden'));
    else lastInput = performance.now();
  });
  document.addEventListener('visitorConsentCollected', () => { if (!allowed()) trackers.forEach(t => t.revoke()); });
  global.addEventListener('pagehide', () => trackers.forEach(t => t.close('page_exit')));
  global.NyeEngagement = Object.freeze({ version: 1, allowed, publish, createGame });
})(window);
